import React from "react";
import SimpleHeader from "./components/Header/SimpleHeader";


const index = (props) => {
  const { children, config } = props;
  const {
    title,
    settings: {
      layout: {
        config: { header,  headerTitle,disableBack,showReport },
      },
    },
  } = config;
  const isHeader = !header;
 
  return (
    <div className="App-ltr">

      {isHeader && <AppHeader showReport={showReport} disableBack={disableBack} headerTitle={headerTitle} title={title} />}

      <main   style={{position:'relative',top:'3em', height:"calc(100vh - 3em)" }}>{children}</main>

    </div>
  );
};

const AppHeader=({headerTitle,title,disableBack,showReport})=>{
 return(
         <SimpleHeader showReport={showReport} disableBack={disableBack} header={headerTitle} title={title}/>
 )
}   


export default index;
